import {
  Modal,
  NewButton,
  NewButtonVariant,
} from "@visiblethread/react-components";
import { modalTypes } from "constants/types";
import DateSearchFilter from "pages/capture/OpportunitySearch/SearchFilters/DateSearchFilter";
import { func, shape, string } from "prop-types";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "slices/app/actions/modals";

import { getErrorMessage } from "./helpers";

const LastUpdatedCustomRangeModal = ({ onOk, additionalFilters }) => {
  const dispatch = useDispatch();
  const [dates, setDates] = useState({
    fromDate: additionalFilters.postedFrom || null,
    toDate: additionalFilters.postedTo || null,
  });

  const handleCancel = () => {
    dispatch(hideModal(modalTypes.LAST_UPDATED_CUSTOM_RANGE));
  };

  const handleSubmit = () => {
    onOk(dates.fromDate, dates.toDate);
    dispatch(hideModal(modalTypes.LAST_UPDATED_CUSTOM_RANGE));
  };

  const onChange = (value, key) => {
    setDates({ ...dates, [key]: value });
  };

  const isSubmitDisabled = () => getErrorMessage(dates) !== null;

  return (
    <Modal className="fade-in" backdrop centered show onDismiss={handleCancel}>
      <Modal.Header>
        <b>Custom Last Updated</b>
      </Modal.Header>
      <Modal.Body>
        <DateSearchFilter
          label="Last Updated"
          fromKey="fromDate"
          toKey="toDate"
          filter={dates}
          onChange={onChange}
        />
      </Modal.Body>
      <Modal.Footer>
        <NewButton variant={NewButtonVariant.l2} onClick={handleCancel}>
          Cancel
        </NewButton>

        <NewButton
          variant={NewButtonVariant.l1}
          onClick={handleSubmit}
          disabled={isSubmitDisabled()}
          error={getErrorMessage(dates)}
        >
          Apply
        </NewButton>
      </Modal.Footer>
    </Modal>
  );
};

export default LastUpdatedCustomRangeModal;

LastUpdatedCustomRangeModal.propTypes = {
  onOk: func.isRequired,
  additionalFilters: shape({
    postedFrom: string,
    postedTo: string,
  }),
};
